import { Link, useParams } from "react-router-dom";
import ProductCard from "../components/ProductCard.js";
import { categoryBySlug } from "../data/categories.js";

const CategoryPage = () => {
  const { categorySlug } = useParams();
  const category = categoryBySlug[categorySlug];

  if (!category) {
    return (
      <main className="min-h-screen bg-containx-navy p-6 text-center text-white">
        <h1 className="mb-4 text-3xl font-bold">Category not found</h1>
        <Link to="/products" className="underline">View all products</Link>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-containx-navy p-6 text-white">
      <div className="mx-auto max-w-6xl">
        <nav className="mb-6 text-sm">
          <Link to="/products" className="underline">Products</Link>
          <span aria-hidden="true"> / </span>
          <span>{category.name}</span>
        </nav>
        <h1 className="mb-3 text-center text-4xl font-bold">{category.name}</h1>
        <p className="mx-auto mb-8 max-w-3xl text-center">{category.description}</p>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {category.products.map((product) => (
            <ProductCard key={product.slug} product={product} />
          ))}
        </div>
      </div>
    </main>
  );
};

export default CategoryPage;

